"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadImageFromElement = void 0;
var _htmlToImage = require("html-to-image");
/* istanbul ignore file @preserve -- not testable */

const downloadImageFromElement = async ({
  element,
  fileName = 'download.png',
  options
}) => {
  const url = await (0, _htmlToImage.toPng)(element, {
    pixelRatio: 3,
    ...options
  });
  if (!url) {
    return;
  }
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
};
exports.downloadImageFromElement = downloadImageFromElement;
